import React from 'react';

import { FaYarn, FaGift, FaHome } from 'react-icons/fa';
import {
  AiFillLinkedin,
  AiFillYoutube,
  AiFillTwitterCircle,
  AiFillGithub,
} from 'react-icons/ai';

export const links = [
  {
    id: 1,
    text: 'home',
    url: '/',
  },
  {
    id: 2,
    text: 'about',
    url: '/about',
  },
  {
    id: 3,
    text: 'products',
    url: '/products',
  },
  {
    id: 4,
    text: 'ContactUs',
    url: '/contact',
  },
];

export const socialLinks = [
  {
    id: 1,
    icon: <AiFillGithub className='github' color='var(--clr-primary-5)' fontSize='2.5rem' />,
    text: 'GitHub',
    url: 'https://github.com/varunKT001/tomper-wear-ecommerce/',
  },
  {
    id: 2,
    icon: (
      <AiFillLinkedin className='linkedin' color='var(--clr-primary-5)' fontSize='2.5rem' />
    ),
    text: 'LinkedIn',
    url: 'https://www.linkedin.com/in/varun-tiwari-454591178',
  },
  {
    id: 3,
    icon: (
      <AiFillTwitterCircle
        className='twitter'
        color='var(--clr-primary-5)'
        fontSize='2.5rem'
      />
    ),
    text: 'Twitter',
    url: 'https://twitter.com/geekvarun',
  },
  {
    id: 4,
    icon: (
      <AiFillYoutube className='youtube' color='var(--clr-primary-5)' fontSize='2.5rem' />
    ),
    text: 'YouTube',
    url: 'https://www.youtube.com/channel/UCUvO6rXuF7VuGhHQI94NIug',
  },
];

export const footerLinks = [
  {
    id: 1,
    text: 'Home',
    url: '/',
  },
  {
    id: 2,
    text: 'About',
    url: '/about',
  },
  {
    id: 3,
    text: 'Products',
    url: '/products',
  },
  {
    id: 4,
    text: 'Contact',
    url: '/contact',
  },
  {
    id: 5,
    text: 'Orders',
    url: '/orders',
  },
];


export const services = [
  {
    id: 1,
    icon: <FaYarn />,
    title: 'handmade quality',
    text: 'Each product is carefully handmade with love using high-quality wool for long-lasting beauty.',
  },
  {
    id: 2,
    icon: <FaHome />,
    title: 'home decor',
    text: 'Add charm to your space with our unique wool flowerpots and creative crochet decor items.',
  },
  {
    id: 3,
    icon: <FaGift />,
    title: 'perfect gifting',
    text: 'Surprise your loved ones with thoughtful, handcrafted wool gifts for any special moment.',
  },
];


const domain = process.env.REACT_APP_BACKEND_HOST;
export const products_url = `${domain}/api/products`;
export const single_product_url = `${domain}/api/products/`;
export const create_order_url = `${domain}/api/orders/new`;
export const get_order_url = `${domain}/api/orders`;
export const payment_url = `${domain}/api/payment/create-payment-intent`;
export const upload_url = `${domain}/api/upload/`;
export const default_profile_image =
  'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg';
